import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
    const [isRegister, setIsRegister] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { login, register } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const result = isRegister
            ? await register(email, password, name)
            : await login(email, password);

        setLoading(false);

        if (result.success) {
            navigate('/');
        } else {
            setError(result.error);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <h1 className="login-title">Health Tracker</h1>
                <h2 className="login-subtitle">{isRegister ? 'Регистрация' : 'Вход'}</h2>

                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit} className="login-form">
                    {isRegister && (
                        <div className="form-group">
                            <label htmlFor="name">Имя</label>
                            <input
                                id="name"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Введите имя"
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="your@email.com"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Пароль</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            minLength={6}
                            placeholder="Минимум 6 символов"
                        />
                    </div>

                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? 'Загрузка...' : (isRegister ? 'Зарегистрироваться' : 'Войти')}
                    </button>
                </form>

                <div className="toggle-mode">
                    {isRegister ? 'Уже есть аккаунт? ' : 'Нет аккаунта? '}
                    <button
                        type="button"
                        className="link-btn"
                        onClick={() => {
                            setIsRegister(!isRegister);
                            setError('');
                        }}
                    >
                        {isRegister ? 'Войти' : 'Зарегистрироваться'}
                    </button>
                </div>

                {!isRegister && (
                    <div className="demo-hint">
                        <strong>Демо-доступ:</strong><br />
                        👤 demo@healthtracker.com / demo123<br />
                        � user@healthtracker.com / user123<br />
                        �👨‍💼 admin@healthtracker.com / admin123
                    </div>
                )}
            </div>
        </div>
    );
};

export default Login;
